export const FreteCaminhoneiroStatusCarregamentoEnum = {
  AGENDADO: 'Agendado',
  AGUARDANDO_AVALIACAO: 'Aguardando avaliação',
  A_CAMINHO_PATIO: 'A caminho do pátio',
  NO_PATIO: 'No pátio',
  CHAMADO: 'Chamado',
  A_CAMINHO_ARMAZEM: 'A Caminho do Armazém',
  NO_ARMAZEM: 'No Armazém',
  EM_CARREGAMENTO: 'Em carregamento',
  EM_VIAGEM: 'Em Viagem',
  EM_DESCARREGAMENTO: 'Em descarregamento',
  VIAGEM_FINALIZADA: 'Viagem Finalizada',
  FINALIZADO: 'Finalizado',
  CANCELADO: 'Cancelado',
  RECUSADO_MOTORISA: 'Agendamento Recusado',
  FINALIZADO_APP: 'Finalizado APP',
};

export const LISTA_STATUS_FINAIS = [
  FreteCaminhoneiroStatusCarregamentoEnum.FINALIZADO,
  FreteCaminhoneiroStatusCarregamentoEnum.CANCELADO,
  FreteCaminhoneiroStatusCarregamentoEnum.RECUSADO_MOTORISA,
  FreteCaminhoneiroStatusCarregamentoEnum.FINALIZADO_APP,
];
